exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-autocomplete[data-v-497fb1f4]{margin-bottom:10px\n}", ""]);

// exports
